import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import strs from './strings';
import { DraftSaved, SubmitApplicationPopup, ReceiveNotificationPopup } from './Popups';
import { countries } from './countries'
import Select, { createFilter, useStateManager } from 'react-select';
import caseTerms from './case';
import curCase from './testCase';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { FormContext } from './context';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {uploadFile, deleteFile, getFile, dataURLtoFile } from './googleCloudStorage';
import { useAuth } from './context';
import { getFirestoreCollection, getFirestoreDoc, getGlobalDocs, getUser, saveSignature, setCase, setFirestoreDoc } from './firestore';
import { auth } from './firebase';
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Popover, Radio, RadioGroup, Tooltip, Typography, useMediaQuery, useStepContext } from '@mui/material';
import { doc, setDoc } from 'firebase/firestore';
import { dateString, validateNewCaseForm } from './utilFunctions';
import { nanoid } from 'nanoid';
import styled from '@emotion/styled';
import spanish_provinces from './spanish_provinces';
// import newCaseImg from './imgs/new-case.png';
import newCaseImg from './imgs/test.svg';
import SignatureCanvas from 'react-signature-canvas';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { MyPDFDownloadLink } from './pdf/PDFDownloader';
import { ComEmpleo, ComExencionTasa, DecRespAutorizaciones } from './pdf/PDFTemplates';
import { HelpOutline, SignalWifiStatusbarConnectedNoInternet4Rounded } from '@mui/icons-material';
import { maxHeight } from '@mui/system';


const lang = strs.en;
const countries_list = countries.en;
const civilStatusOptions = lang.civilStatusOptions;
const typeOfStreetOptions = lang.typeOfStreetOptions;

const colorStyles = {
	control: (styles) => ({
		...styles,
		backgroundColor: '#f5f6f7',
		border: '2px solid gray !important',
		minHeight: '48px',
		marginLeft: '-8px',
		boxSizing: 'border-box',
	}),
	menuPortal: base => ({
		...base,
		fontSize: '1.1rem',
		highlightColor: 'green',
	}),
	option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#dcebfc' : '#ffffff', 
		color: '#333333',
    }),


}

const colorStylesError = {
	control: (styles) => ({
		...styles,
// 		color: 'black',
		backgroundColor: '#f5f6f7',
// 		border: '2px solid #DB5755',
// 		minWidth: '636px',
// 		minHeight: '48px',
// 		margin: '1rem'
// 		width: '102.65%',
		border: '2px solid red !important',
		minHeight: '48px',
		marginLeft: '-8px',
		boxSizing: 'border-box',

	}),
	menuPortal: base => ({
		...base,
		fontSize: 'inherit',
	}),
	option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#dcebfc' : '#ffffff', 
		color: '#333333',
    }),
}


export function Spacer() {
	return (
		<div className="spacer"></div>
	);
}

export function Spacer5() {
	return (
		<div className='spacer-5'></div>
	)
}

export function Spacer10() {
	return (
		<div className='spacer-10'></div>
	)
}

export function Spacer25() {
	return (
		<div className="spacer-25"></div>
	);
}

export function Spacer100() {
	return (
		<div className="spacer-100"></div>
	);
}


export function EmptyElement() {
	return (<div></div>);
}

export function Notification(props) {
	//Required props:
	//props.setNotification
	//props.addToReceivedNotification
	const [text, setText] = useState(caseTerms.activeNotification);	
	const [receivePopup, setReceivePopup] = useState('hidden');
	let notification = props?.notification;
	const [receiving, setReceiving] = useState(notification?.receiving);
	console.log('notification', notification)

	const now = Date.now();
	const notifiedOn = notification.notifiedOn;
	const deltaDays = Math.floor ( ( now - (notifiedOn * 1000) ) / ( 86400 * 1000) );
	
	let daysReceivedMsg = caseTerms.daysAgo.replace("DAYS", deltaDays);
	
	if (deltaDays === 1) {
		daysReceivedMsg = daysReceivedMsg.replace("days", "day");
	}

	function onMouseEnter() {
		setText(caseTerms.receiveNotification);	
	}

	function onMouseLeave() {
		setText(caseTerms.activeNotification);
	}

	function receiveNotification() {
		setReceivePopup('animated-div');	
	}


	return receiving ? (
		<div>
			<p className='centered-text'>{caseTerms.notificationDisclaimer}</p>
			<Spacer25 />
			<div
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				onClick={receiveNotification}
				className='drag-n-drop grow-and-shrink-slightly notification'>
				<div className='grid-column'>
					<p className='p larger-font'><b>{caseTerms.receiving}</b></p>
					<Spacer10 />
					<p className='p larger-font'>{caseTerms.receivingNotification}</p>	
					<Spacer10 />
					<p className='p centered-text'>{daysReceivedMsg}</p>
				</div>
			</div>
			<ReceiveNotificationPopup 
				thisNotification={notification}
				trigger={receivePopup} 
				submitPopup={receivePopup} 
				closeFunc={setReceivePopup} 
				setNotification={props.setNotification} 
				addToReceivedNotifications={props.addToReceivedNotifications}
			/>
		</div>
	)
		: (
		<div>
			<p className='centered-text'>{caseTerms.notificationDisclaimer}</p>
			<Spacer25 />
			<div
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				onClick={receiveNotification}
				className='drag-n-drop grow-and-shrink-slightly notification'>
				<div className='grid-column'>
					<p className='p larger-font'>{text}</p>	
					<Spacer10 />
					<p className='p centered-text'>{daysReceivedMsg}</p>
				</div>
			</div>
			<ReceiveNotificationPopup 
				thisNotification={notification}
				trigger={receivePopup} 
				submitPopup={receivePopup} 
				closeFunc={setReceivePopup} 
				setNotification={props.setNotification} 
				addToReceivedNotifications={props.addToReceivedNotifications}
				setReceiving={setReceiving}
			/>
		</div>
		);
}

export function LoadingDocs() {
	return(
	<div className='animated-div'>
		<Spacer100 />
		<h2 className='secondary-title centered-text '><i>{lang.loadingDocs}</i></h2>
		<Spacer />
		<div className='center-flex logo-loading-rotate'>
			<img className='header__logo' alt="logo" src='/spinningLogo.png' />
		</div>
	</div>
	);
}


export function ChooseAvailableFile({uploadCallback}) {
	const [selecting, setSelecting] = useState('hidden');
	const [uploadedFile, setUploadedFile] = useState(null);
	const {curCase, setCurCase, caseDocURLs, setCaseDocURLs, formData, setFormData} = useContext(FormContext);
	const globalForm = curCase;
	const setGlobalForm = setCurCase;
	console.log('globalForm', globalForm);
	console.log('caseDocURLs from context', caseDocURLs)

	console.log('uploadCallback', uploadCallback)

	function handleEscapePress(event) {
		console.log('handleEscapePress')
		if (event.key === 'Escape') setSelecting('hidden');
	}

	useEffect(
		() => {
			document.addEventListener('keyup', handleEscapePress);
		},
		[]
	)

	function handleFileUpload(file) {
		console.log('file upload file', file);
		setUploadedFile(file.url)
		uploadCallback(file);
		setSelecting('hidden')
		//setGlobalForm and update Case
		console.log('AvailableFile formData', formData);
		console.log('AvailableFile formData.docType', formData.docType);
		const tmpForm = {
			...globalForm,
			docs: [
				...globalForm.docs,
				{
					docType: formData.docType, 
					uuid: file.uuid, 
					uploadTime: Date.now() / 1000,
					url: file.url,
					extension: "pdf",
					message: formData.textArea,
				}
			]
		}
		setGlobalForm(tmpForm);
		setCaseDocURLs({
			...caseDocURLs,
			[formData.docType]: file.url,
		})
		setCaseDocURLs({
			...caseDocURLs,
			[Object.keys(caseDocURLs).length]: {
				uuid: file.uuid,
				url: file.url,
				docType: formData.docType,
			},
		})

// 		setCase(tmpForm.id, tmpForm);
	}

	function dummy() {
	}

	function handleClick(){
		if (uploadedFile !== null) return;
		setSelecting('popup')
	}

	return(
		<div>
		{
			selecting ? <AvailableDocSelect visible={selecting} callbackFunc={handleFileUpload}/> : <></>
		}
			<Spacer25 />
			<div className='drag-n-drop grow-and-shrink-slightly notification' onClick={handleClick}>
			{
				uploadedFile ?
					<PDFViewer
						large={false} 
						noX={false} 
						delFile={dummy}
						delStatus={dummy}
						setPreviewImg={setUploadedFile}
						setGlobalForm={setGlobalForm}
						file={uploadedFile} 
						customStyle={'pdf-viewer-medium'} 
				/> :
					<p className='secondary-title-center'>{lang.chooseFile}</p>	
			}
			</div>
		</div>
	);
}


export function AvailableDocSelect({callbackFunc, visible}) {
	const [availableDocs, setAvailableDocs] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	function handleClick(doc) {
	//Return file to parent
		callbackFunc(doc);
		
	}

	useEffect(
		() => {
			const wrapperFunction = async () => {
				const userDocs = await getGlobalDocs();
				const fetchDocs = await Promise.all(userDocs.docs.map(async (doc) => {
					const file = await getFile(doc.uuid)
					const url = URL.createObjectURL(file);
					doc.url = url;
					return doc; // Ensure to return doc for Promise.all
				}
				));
				setAvailableDocs(fetchDocs);
				setIsLoading(false);
			}
			wrapperFunction();
		}
		,[]
	);

	return (
	isLoading? 
		<div className={`popup ${visible}`}>
			<LoadingDocs /> 
		</div>

	
	:
	<div className={`${visible}`}>
	<Spacer />
	<h1 className='secondary-header'>{lang.uploadedDocs}</h1>
	<Spacer />
	<div className='upload-grid from-div animated-div popup-content'>
	{
		availableDocs.map( (doc) => (
			<div key={nanoid()}>
			<div className='grow-and-shrink-slightly'>
				<PDFViewer large={false} noX={true} file={doc.url} clickCallback={() => handleClick(doc)} customStyle={'pdf-viewer-medium'} />
			</div>

			</div>
		))
	}
	</div>
	</div>
	)
}

export function PDFViewer(props) {
	const file = props.file;
	const docType = props.doc;
// 	console.log('PDFViewer props', props);
	const {globalForm, setGlobalForm} = useContext(FormContext);
	const [cannotDelete, setCannotDelete] = useState(null);
	
	async function handleX() {

		console.log('handleX, globalForm', globalForm)

// 		console.log('file to delete', file)
// 		console.log('file uuid', props.fileNanoID);
// 		console.log('doc', props.docType);
// 		console.log('props', props);
// 		let globalForm = props.globalForm;
// 		let setGlobalForm = props.setGlobalForm;

		const uid = auth.currentUser.uid;
		const cases = await getFirestoreCollection(`/users/${uid}/cases`);
		if (!cases) return;
		console.log('handleX, cases', cases);

		for (let key in cases) {
			const curCase = cases[key];
			if (curCase?.curStatus !== 'created') {
				const curCaseDocs = curCase.docs;
				for (let i = 0; i < curCaseDocs.length; i++) {
					if (curCaseDocs[i]?.uuid === props.fileNanoID) {
						setCannotDelete("Cannot delete. In active case.");	
						return
					}
				}
			} 
		}

		
		const tmpGlobalForm = {
			...globalForm,
			basicInfo: {
				...globalForm.basicInfo,
				dateOfBirth: globalForm.basicInfo?.dateOfBirth?.toISOString(),
			},
			docs: globalForm.docs.filter(doc => {
					console.log('thisDoc', doc)
					return !(doc.uuid === props.fileNanoID)
				}),
		}

		setGlobalForm(tmpGlobalForm);
		console.log('tmpGlobalForm form edited', tmpGlobalForm);

// 		await new Promise(resolve => setTimeout(resolve, 1000)); // Sleep for 1000 milliseconds

		console.log('After state update:', globalForm);
// 		debugger
		
		if (props.delFromDatabase) {
			if (props.fileNanoID.then)
				props.fileNanoID.then(deleteFile);
			else if (props.fileNanoID)
				console.log('deleting file')
				deleteFile(props.fileNanoID);
		}

	//Ugly but this determines whether or not we are dealing with a case. This will not execute if we are on the docs page.
		if (tmpGlobalForm.id) {
			console.log('tmpGlobalForm.id', tmpGlobalForm.id);
			setCase(tmpGlobalForm.id, tmpGlobalForm);
		}

		props.delFile(<p className='p-gray'>{lang.dragNDrop}</p>);
		props.delStatus(<EmptyElement />);
		props.setPreviewImg(null);


	}

	function testClick() {
		props.clickCallback && props.clickCallback(file);
	}

	return(
		<div className={`${props.noX ? '' : 'iframe-with-x'}`}>
			<div className='container' onClick={testClick}>
			<embed className={`pdf-viewer ${props.customStyle} ${props.large ? 'large-iframe' : ''}`} title="upload-box" src={file} />
				<div 
					className='iframe-overlay'
				></div>
			</div>
			{
				props.msg ?
				<div>
					<Spacer10 />
					<p className='p'>{`${lang.message}`}: <i>{`${props?.msg}`}</i></p>
					<Spacer10 />
				</div>
				:

				<div>
					<Spacer10 />
					<p className='p'>&nbsp;</p>
					<Spacer10 />
				</div>
			}
		{ !props.noX && (
			cannotDelete ? <p className='little-popup alert'>{cannotDelete}</p> :	
				<button className='del-button grow-and-shrink-slightly' onClick={() => handleX()}>Delete</button>
		)
		}

		</div>
	);

}


export function DragNDrop(props) {
	let [uploadStatus, setUploadStatus] = useState(EmptyElement());
	let [ previewImg, setPreviewImg ] = useState(null);
	let [previewFrame, setPreviewFrame] = useState(<p className='p-gray' style={{textAlign: 'center'}}>{lang.dragNDrop}</p>);
	let [largeSize, setLargeSize] = useState(false);
	const [hovered, setHovered] = useState(false);
//caseDocURLs and setCaseDocURLs might not exist. That's okay. We just need to set them if they do.
	const {globalForm, setGlobalForm, globalDocs, setGlobalDocs, caseDocURLs, setCaseDocURLs, formData, setFormData, activeDragNDrop, setActiveDragNDrop, resolverRef } = useContext(FormContext);
	const fileInputRef = useRef(null);

	const [supportsHover, setSupportsHover] = useState(false);

	useEffect(() => {
		setSupportsHover(window.matchMedia('(hover: hover)').matches);

		if (props.initialFileURL) {
			setPreviewImg(props.initialFileURL);
			setPreviewFrame(
				<PDFViewer
					file={props.initialFileURL}
					delFile={setPreviewFrame}
					delStatus={setUploadStatus}
					setPreviewImg={setPreviewImg}
					large={props.large}
					globalForm={globalForm}
					setGlobalForm={setGlobalForm}
					clickCallback={props.clickCallback}
					customStyle={props.customStyle}
					fileNanoID={props.fileNanoID}
					delFromDatabase={props.documentsPage ? true : false}
					saveFunc={props.saveFunc}
					caseID={props.caseID}
					docType={props.doc}
					msg={props?.msg}
				/>
			);
		}
	}, [props.initialFileURL]);

	function DropResult(props) {
		console.log(props.text);
		return(
			<div>
				<p className='p center-flex'>Uploaded {props.text} successfully!</p>
			</div>
		);
	}

	async function handleBriefcaseImport() {
		props?.setBriefcasePopup('fade-in');
		let result = await new Promise((resolve) => {
			resolverRef.current = resolve;
		});
		console.log('resolved resolverRef', result);
		setPreviewImg(result.url);
		setPreviewFrame(
			<PDFViewer
				file={result.url}
				delFile={setPreviewFrame}
				delStatus={setUploadStatus}
				setPreviewImg={setPreviewImg}
				large={props.large}
				globalForm={globalForm}
				setGlobalForm={setGlobalForm}
				clickCallback={props.clickCallback}
				customStyle={props.customStyle}
				fileNanoID={props.fileNanoID}
				delFromDatabase={props.documentsPage ? true : false}
				saveFunc={props.saveFunc}
				caseID={props.caseID}
				docType={props.doc}
				msg={props?.msg}
			/>
		);


		if (globalForm.docs) {
			console.log('globalForm.docs exists');
			const tmpForm = {
				...globalForm,
				docs: [
					...globalForm.docs,
					{ docType: props.doc, uuid: result.nanoID, url: result.url},
				],
			}
			setGlobalForm(tmpForm);
			console.log('tmpForm', tmpForm);
			if (props.saveFunc)
				props.saveFunc(tmpForm);
		}

		if (caseDocURLs && setCaseDocURLs && formData && setFormData) {
			console.log('setting case doc')
			setCaseDocURLs({
				...caseDocURLs,
				[formData.docType]: result.url,
			})
			setCaseDocURLs({
				...caseDocURLs,
				[Object.keys(caseDocURLs).length]: {
					docType: formData.docType,
					uuid: result.nanoID,
					uploadTime: Date.now() / 1000,
					url: result.url,
					extension: "pdf",
					message: formData.textArea,

				},
			});
		}



	}

	async function handleFiles(files) {
		console.log('handle files', files);
		let file = files[0];
		const fileURL = URL.createObjectURL(file);

		if (!props.uploadCallback) {
			setUploadStatus(DropResult({text: file.name}));
		}

		const fileNanoID = await uploadFile(file, props.doc);

		if (globalForm.docs) {
			console.log('globalForm.docs exists');
			const tmpForm = {
				...globalForm,
				docs: [
					...globalForm.docs,
					{ docType: props.doc, uuid: fileNanoID, url: fileURL},
				],
			}
			setGlobalForm(tmpForm);
			console.log('tmpForm', tmpForm);
			if (props.saveFunc)
				props.saveFunc(tmpForm);
		}

		if (caseDocURLs && setCaseDocURLs && formData && setFormData) {
			console.log('setting case doc')
			setCaseDocURLs({
				...caseDocURLs,
				[formData.docType]: file.url,
			})
			setCaseDocURLs({
				...caseDocURLs,
				[Object.keys(caseDocURLs).length]: {
					docType: formData.docType,
					uuid: file.uuid,
					uploadTime: Date.now() / 1000,
					url: fileURL,
					extension: "pdf",
					message: formData.textArea,

				},
			});
		}

		setPreviewImg(file);
		setPreviewFrame(
		<PDFViewer
			file={fileURL}
			delFile={setPreviewFrame}
			delStatus={setUploadStatus}
			setPreviewImg={setPreviewImg}
			large={props.large}
			docType={props.doc}
			globalForm={globalForm}
			setGlobalForm={setGlobalForm}
			clickCallback={props.clickCallback}
			customStyle={props.customStyle}
			fileNanoID={fileNanoID}
			delFromDatabase={true} // Always delete from the database
			saveFunc={props.saveFunc}
			caseID={props.caseID}
		/>
	);

		if (props.uploadCallback) {
			props.uploadCallback(fileURL);
			console.log('uploaded file', fileURL)
		}
	}


// 	const handleDivClick = () => {
// 		console.log('file picker');
// 		console.log(`previewImg: ${previewImg}`)
// 		if (previewImg === null) {
// 			fileInputRef.current.value = null; // force change trigger even if same file
// 			console.log('fileInputRef.current:', fileInputRef.current);
// 			fileInputRef.current.click();
// 		}
// 		else{
// 			setLargeSize(!largeSize);
// 		}
// 	}

	const handleDivClick = () => {
		console.log('file picker');
		console.log(`previewImg: ${previewImg}`);
		if (previewImg !== null) {
			setLargeSize(!largeSize);
		}
		// Don't call `.click()` here at all
	};

	const handleFileSelect = (event) => {
		console.log('handleFileSelect');
		const files = event.target.files;
		console.log(files);
		if (files.length > 0) {
			handleFiles(files)
		}
	}

	function onDrop(ev){
		console.log('ONDROP')
		ev.preventDefault();
		let files = ev.dataTransfer.files;
		handleFiles(files);
	}



return (
	<div
		onMouseEnter={() => supportsHover && setHovered(true)}
		onMouseLeave={() => {
		  supportsHover && setHovered(false);
		  setUploadStatus(null);
		}}
	>
	<input
		type="file"
		ref={fileInputRef}
		onChange={handleFileSelect}
		style={{ display: 'none' }}
	/>
    {
      hovered && previewImg === null ? (
        <>
		  <div className='drag-n-drop-title'>
			  <center><p className='p-gray centered-text'>{props.text || <p>&nbsp;</p>}</p></center>
		  </div>
          <Spacer25 />
          <div
            className={`${props.large ? "drag-n-drop-large" : "drag-n-drop"} ${previewImg ? '' : 'grow-and-shrink-slightly'}`}
            onDrop={onDrop}
            onDragOver={(e) => e.preventDefault()}
          >
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <Button
                className='drag-n-drop'
                sx={{ minWidth: '50%' }}
                onClick={() => {
                  fileInputRef.current.value = null;
                  fileInputRef.current.click();
                }}
              >
                Upload from file system
              </Button>
            </div>
            <div style={{ position: 'relative', display: 'inline-block' }}>
				<Button 
					onClick={async () =>{
						let r = await handleBriefcaseImport();	
						console.log('RESOLVER-REF-CURRENT', r);
					}} 
					className='drag-n-drop'
					sx ={{
						minWidth: '50%',
					}}	
				>
					Import from briefcase
				</Button>

			</div>
          </div>
        </>
      ) : (
        <div>
		  <div className='drag-n-drop-title'>
			  <center><p className='p-gray centered-text'>{props.text || <p>&nbsp;</p>}</p></center>
		  </div>
          <Spacer25 />
          <div
            className={`${props.large ? "drag-n-drop-large" : "drag-n-drop"} ${previewImg ? '' : 'grow-and-shrink-slightly'}`}
            onDrop={onDrop}
            onDragOver={(e) => e.preventDefault()}
            onClick={() => {
              if (!supportsHover) {
                setSupportsHover(true);
                setHovered(true);
              }
            }}
          >
            {previewFrame}
          </div>
        </div>
      )
    }
  </div>
);
}


export function DragNDropBriefcase(props) {
	let [uploadStatus, setUploadStatus] = useState(EmptyElement());
	let [ previewImg, setPreviewImg ] = useState(null);
	let [previewFrame, setPreviewFrame] = useState(<p className='p-gray' style={{textAlign: 'center'}}>{lang.dragNDrop}</p>);
	let [largeSize, setLargeSize] = useState(false);
	const {currentUser} = useAuth();
//caseDocURLs and setCaseDocURLs might not exist. That's okay. We just need to set them if they do.
	const {globalForm, setGlobalForm, caseDocURLs, setCaseDocURLs, formData, setFormData} = useContext(FormContext);
// 	const globalForm = props.globalForm
// 	const setGlobalForm = props.setGlobalForm
// 	console.log('global form', globalForm);
	const fileInputRef = useRef(null);

// 	console.log('DragNDrop props', props);

	useEffect(() => {
		if (props.initialFileURL) {
			setPreviewImg(props.initialFileURL);
			setPreviewFrame(
				<PDFViewer
					file={props.initialFileURL}
					delFile={setPreviewFrame}
					delStatus={setUploadStatus}
					setPreviewImg={setPreviewImg}
					large={props.large}
					globalForm={globalForm}
					setGlobalForm={setGlobalForm}
					clickCallback={props.clickCallback}
					customStyle={props.customStyle}
					fileNanoID={props.fileNanoID}
					delFromDatabase={props.documentsPage ? true : false}
					saveFunc={props.saveFunc}
					caseID={props.caseID}
					docType={props.doc}
					msg={props?.msg}
					noX={props?.noX}
				/>
			);
		}
	}, [props.initialFileURL]);

	function DropResult(props) {
		console.log(props.text);
		return(
			<div>
				<p className='p center-flex'>Uploaded {props.text} successfully!</p>
			</div>
		);
	}

	function onDrop(ev){
		ev.preventDefault();
		let files = ev.dataTransfer.files;
		handleFiles(files);
	}

	async function handleFiles(files) {
		console.log('handle files', files);
		let file = files[0];
		const fileURL = URL.createObjectURL(file);

		if (!props.uploadCallback) {
			setUploadStatus(DropResult({text: file.name}));
		}

		const fileNanoID = await uploadFile(file, props.doc);

		if (globalForm.docs) {
			console.log('globalForm.docs exists');
			const tmpForm = {
				...globalForm,
				docs: [
					...globalForm.docs,
					{ docType: props.doc, uuid: fileNanoID, url: fileURL},
				],
			}
			setGlobalForm(tmpForm);
			console.log('tmpForm', tmpForm);
			if (props.saveFunc)
				props.saveFunc(tmpForm);
		}

		if (caseDocURLs && setCaseDocURLs && formData && setFormData) {
			console.log('setting case doc')
			setCaseDocURLs({
				...caseDocURLs,
				[formData.docType]: file.url,
			})
			setCaseDocURLs({
				...caseDocURLs,
				[Object.keys(caseDocURLs).length]: {
					docType: formData.docType,
					uuid: file.uuid,
					uploadTime: Date.now() / 1000,
					url: fileURL,
					extension: "pdf",
					message: formData.textArea,

				},
// 
// 					docType: formData.docType, 
// 					uuid: file.uuid, 
// 					uploadTime: Date.now() / 1000,
// 					url: file.url,
// 					extension: "pdf",
// 					message: formData.textArea,
// 
			})

		}


		setPreviewImg(file);
		setPreviewFrame(
		<PDFViewer
			file={fileURL}
			delFile={setPreviewFrame}
			delStatus={setUploadStatus}
			setPreviewImg={setPreviewImg}
			large={props.large}
			docType={props.doc}
			globalForm={globalForm}
			setGlobalForm={setGlobalForm}
			clickCallback={props.clickCallback}
			customStyle={props.customStyle}
			fileNanoID={fileNanoID}
			delFromDatabase={true} // Always delete from the database
			saveFunc={props.saveFunc}
			caseID={props.caseID}
			noX={props?.noX}
		/>
	);

		if (props.uploadCallback) {
			props.uploadCallback(fileURL);
			console.log('uploaded file', fileURL)
		}
	}


	const handleDivClick = () => {
		console.log('file picker');
		console.log(`previewImg: ${previewImg}`)
		if (previewImg === null)
			fileInputRef.current.click();
		else{
			setLargeSize(!largeSize);
		}
	}

	const handleFileSelect = (event) => {
		const files = event.target.files;
		console.log(files);
		if (files.length > 0) {
			handleFiles(files)
		}
	}

	return (
		<div>
			<p className='p-gray centered-text'>{
				props.text ? props.text : <p>&nbsp;</p>
			}</p>
			<Spacer25 />
			<div className={ `${props.large ? "drag-n-drop-large" : "drag-n-drop"} grow-and-shrink-slightly` }
				onDrop={(ev) => onDrop(ev)} 
				onDragOver={(event) => event.preventDefault()}
				onClick={handleDivClick}>
				{previewFrame}
			</div>
			<input
				type="file"
				ref={fileInputRef}
				style={{ display: 'none' }}
				onChange={ handleFileSelect }
			/>
			<Spacer25 />
			{uploadStatus}
		</div>
	);
}


export function BackButton(props) {
	const navigate = useNavigate();
	return(
		<button 
			className={`back-button`}
			onClick={() => {
				if (props?.popup) props.popup();
				else navigate(-1)
			}}
		>
			<ArrowBackIcon />
		</button>
	);
}



export function Dropdown(props) {
	const dropdown = props.dropdown;
	return (
		<select className='form-text-item'>
		{
			dropdown.map(option => (
				<option value={option.code}>{option.name}</option>
			))
		}
		</select>
	);
}

export function Children({smallChildren, setSmallChildren, setNumChildren}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		noSmallChildren: yup.bool().required(),
	})

	let initialValues;
	if (globalForm?.basicInfo?.smallChildren) {
		initialValues = {smallChildren: globalForm.basicInfo.smallChildren}
		
	}
	else {
		console.log('no small children data')
		initialValues =  {
			smallChildren: false,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		const {name, value} = event.target;
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			basicInfo: {
				...prevGlobalForm.basicInfo,
				[name]: value,
			}
		}) )
		setSmallChildren(value.value);
// 		setNumChildren( prevNumChildren => prevNumChildren + 1 );
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.smallChildren}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.smallChildren && errors.smallChildren ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.smallChildren}
				onChange={selectedOption => {
					let event = {target: {name: 'smallChildren', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.smallChildren && errors.smallChildren ? colorStylesError : colorStyles}
			
			/>
			</div>
		</div>
		
		</>

	);


}

export function LegalStatus({passportStamp, setPassportStamp}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		entryStamp: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.passportStamp) {
		initialValues = {passportStamp: globalForm.passportStamp}
		
	}
	else {
		initialValues =  {
			passportStamp: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		const {name, value} = event.target;
		console.log(name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setPassportStamp(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.iHaveAnEntryStamp}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.passportStamp && errors.passportStamp ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.passportStamp}
				onChange={selectedOption => {
					let event = {target: {name: 'passportStamp', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.passportStamp && errors.passportStamp ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}

export function ThirdPartyNational({thirdPartyNational, setThirdPartyNational}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		entryStamp: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.thirdPartyNational) {
		initialValues = {thirdPartyNational: globalForm.thirdPartyNational}
	}
	else {
		initialValues =  {
			thirdPartyNational: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		const {name, value} = event.target;
		console.log(name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setThirdPartyNational(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.familyThirdPartyNational}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.thirdPartyNational && errors.thirdPartyNational ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.thirdPartyNational}
				onChange={selectedOption => {
					let event = {target: {name: 'thirdPartyNational', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.thirdPartyNational && errors.thirdPartyNational ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}

export function AlreadyStudying({alreadyStudying, setAlreadyStudying}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		entryStamp: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.thirdPartyNational) {
		initialValues = {alreadyStudying: globalForm.alreadyStudying}
	}
	else {
		initialValues =  {
			alreadyStudying: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		const {name, value} = event.target;
		console.log(name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setAlreadyStudying(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.alreadyStudying}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.alreadyStudying && errors.alreadyStudying ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.alreadyStudying}
				onChange={selectedOption => {
					let event = {target: {name: 'alreadyStudying', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.alreadyStudying && errors.alreadyStudying ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}

export function Guardian({guardian, setGuardian}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		entryStamp: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.guardian) {
		initialValues = {guardian: globalForm.guardian}
	}
	else {
		initialValues =  {
			guardian: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		const {name, value} = event.target;
		console.log(name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setGuardian(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.guardian}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.guardian && errors.guardian ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.guardian}
				onChange={selectedOption => {
					let event = {target: {name: 'guardian', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.guardian && errors.guardian ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}

export function Caretaker({caretaker, setCaretaker}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		entryStamp: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.caretaker) {
		initialValues = {caretaker: globalForm.caretaker}
	}
	else {
		initialValues =  {
			caretaker: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		const {name, value} = event.target;
		console.log(name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setCaretaker(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.caretaker}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.guardian && errors.guardian ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.caretaker}
				onChange={selectedOption => {
					let event = {target: {name: 'caretaker', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.caretaker && errors.caretaker ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}



export function AuxCompletionProof({auxCompletion, setAuxCompletion}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		auxCompletion: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.auxCompletion) {
		initialValues = {auxCompletion: globalForm.auxCompletion}
		
	}
	else {
		initialValues =  {
			auxCompletion: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		console.log('called changeHandler()')
		const {name, value} = event.target;
		console.log('logging name, value: ', name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setAuxCompletion(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.auxCompletion}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.auxCompletion && errors.auxCompletion ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.auxCompletion}
				onChange={selectedOption => {
					let event = {target: {name: 'auxCompletion', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.auxCompletion && errors.auxCompletion ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}

export function Licenses({licenses, setLicenses}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		licenses: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.auxCompletion) {
		initialValues = {licenses: globalForm.licenses}
		
	}
	else {
		initialValues =  {
			auxCompletion: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		console.log('called changeHandler()')
		const {name, value} = event.target;
		console.log('logging name, value: ', name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setLicenses(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.licensure}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.auxCompletion && errors.auxCompletion ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.licenses}
				onChange={selectedOption => {
					let event = {target: {name: 'licenses', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.auxCompletion && errors.auxCompletion ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}

export function HaveCompany({company, setCompany}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		company: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.company) {
		initialValues = {company: globalForm.company}
		
	}
	else {
		initialValues =  {
			company: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		console.log('called changeHandler()')
		const {name, value} = event.target;
		console.log('logging name, value: ', name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setCompany(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.otherFirm}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.auxCompletion && errors.auxCompletion ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.company}
				onChange={selectedOption => {
					let event = {target: {name: 'company', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.auxCompletion && errors.auxCompletion ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}

export function ExColony({exColony, setExColony}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		exColony: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.auxCompletion) {
		initialValues = {exColony: globalForm.exColony}
		
	}
	else {
		initialValues =  {
			exColony: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		console.log('called changeHandler()')
		const {name, value} = event.target;
		console.log('logging name, value: ', name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setExColony(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text form-long-text'>{lang.exColonyCitizen}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.auxCompletion && errors.auxCompletion ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.yesNoOptions}
				value={values.exColony}
				onChange={selectedOption => {
					let event = {target: {name: 'exColony', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.auxCompletion && errors.auxCompletion ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}

export function NumJobs({numJobs, setNumJobs}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		numJobs: yup.number().required().integer(),
	})

	let initialValues;
	if (globalForm.auxCompletion) {
		initialValues = {numJobs: globalForm.numJobs}
		
	}
	else {
		initialValues =  {
			numJobs: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		console.log('called changeHandler()')
		const {name, value} = event.target;
		console.log('logging name, value: ', name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setNumJobs(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text'>{lang.numJobsDec}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.auxCompletion && errors.auxCompletion ?
		<p className='alert required-text' for='numJobs'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<input 
				className={`form-text-item ${touched.numJobs && errors.numJobs ? 'input-error' : ''} form-element`} 
				onBlur={handleBlur}
				type="text"
				placeholder={lang.numJobs}
				onChange={changeHandler}
				name="numJobs"
				value={values.numJobs}
			/>

			</div>
		</div>

		</>
	);
}

export function IsEmployerFirm({isEmployerFirm, setIsEmployerFirm}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);


	const basicSchema = yup.object().shape({
		isEmployerFirm: yup.bool().required(),
	})

	let initialValues;
	if (globalForm.isEmployerFirm) {
		initialValues = {isEmployerFirm: globalForm.isEmployerFirm}
		
	}
	else {
		initialValues =  {
			isEmployerFirm: undefined,
		}
	}


	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		console.log('called changeHandler()')
		const {name, value} = event.target;
		console.log('logging name, value: ', name, value)
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[name]: value,
		}) )
		setIsEmployerFirm(value.value);
		handleChange(event);
	}

	return(
		<>
		<Spacer />
		<div>
			<p className='p larger-font centered-text form-long-text'>{lang.isEmployerFirm}&nbsp; <span style={{color: 'red'}}>*</span></p>

		{touched.auxCompletion && errors.auxCompletion ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'></p>}
			<Spacer25 />
			<div className='max-width-100'>
			<Select 
				options={lang.isEmployerFirmOptions}
				value={values.isEmployerFirm}
				onChange={selectedOption => {
					let event = {target: {name: 'isEmployerFirm', value: selectedOption}}
					changeHandler(event);
				}}
				onBlur={handleBlur}
				className='form-select-dropdown'
				styles={ touched.auxCompletion && errors.auxCompletion ? colorStylesError : colorStyles}
			/>
			</div>
		</div>
		</>
	);
}


export function BasicInfoForm() {
	const {globalForm, setGlobalForm} = useContext(FormContext);

	console.log('globalForm validating', globalForm);
	const basicSchema = yup.object().shape({
		firstName: yup.string().required(),
		middleName: yup.string(),
		lastName: yup.string().required(),
		secondLastName: yup.string(),
		passportNumber: yup.string().required(),
		NIE: yup.string().required(),
		dateOfBirth: yup.string().required(),
		countryOfBirth: yup.object().required(),
		placeOfBirth: yup.string().required(),
		countriesOfCitizenship: yup.array().required(),
		gender: yup.object().required(),
		fathersFullName: yup.string().required(),
		mothersFullName: yup.string().required(),
		civilStatus: yup.object().required(),
		noSmallChildren: yup.bool().required(),
	})



	let initialValues;
	if (globalForm.basicInfo) {
		initialValues = globalForm.basicInfo;
		initialValues.dateOfBirth = dayjs(initialValues.dateOfBirth);
		console.log('initial dob: ', initialValues.dateOfBirth);
		console.log('initial values with Date', initialValues);
		
	}
	else {
		initialValues =  {
			firstName: '',
			middleName: '',
			lastName: '',
			secondLastName: '',
			passportNumber: '',
			NIE: '',
			dateOfBirth: '',
			countryOfBirth: '',
			placeOfBirth: '',
			countriesOfCitizenship: '',
			gender: '',
			fathersFullName: '',
			mothersFullName: '',
			civilStatus: '',
			smallChildren: true,
		}
	}

	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});

// 	console.log('BasicForm values', values);
// 	console.log('BasicForm globalForm', globalForm);

	function changeHandler(event) {
		if (event.target.type === 'checkbox') {
			const {name, checked} = event.target;
			setGlobalForm( prevGlobalForm => ({
				...prevGlobalForm,
				basicInfo: {
					...prevGlobalForm.basicInfo,
					[name]: checked,
				}
			}) );
		console.log('globalForm checkbox update', globalForm);
			return;
		}
		const {name, value} = event.target;
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			basicInfo: {
				...prevGlobalForm.basicInfo,
				[name]: value,
			}
		}) )
		handleChange(event);
		console.log('globalForm', globalForm);
	}

	async function checkForm(formData) {
		try {
			await basicSchema.validate(formData, { abortEarly: false });
			return true; // All fields are valid
		} catch (err) {
			console.log(err.errors); // Contains all validation errors
			return false; // At least one field is invalid
		}
	}

	return (
	<form className='basic-form animated-div'>
		<div class='grid-column-left'>
		{touched.firstName && errors.firstName ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'>{lang.firstName}</p>}
		<Spacer5 />
		<input 
			className={`form-text-item ${touched.firstName && errors.firstName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.firstName}
			onChange={changeHandler}
			name="firstName"
			value={values.firstName}
		/>

		</div>

		<div class='grid-column-left'>
		{touched.middleName && errors.middleName ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.middleName}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.middleName && errors.middleName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.middleName}  (${lang.requiredIfHave})`}
			onChange={changeHandler}
			name="middleName"
			value={values.middleName}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.lastName && errors.lastName ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.lastName}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.lastName && errors.lastName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.lastName}
			onChange={changeHandler}
			name="lastName"
			value={values.lastName}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.secondLastName && errors.secondLastName ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.lastName}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.secondLastName && errors.secondLastName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.secondLastName}
			onChange={changeHandler}
			name="secondLastName"
			value={values.secondLastName}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.passportNumber && errors.passportNumber ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.passportNumber}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.passportNumber && errors.passportNumber ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.passportNumber}
			onChange={changeHandler}
			name="passportNumber"
			value={values.passportNumber}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.NIE && errors.NIE ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.NIE}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.NIE && errors.NIE ? 'input-error' : ''} form-element`}
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.NIE} (${lang.requiredIfHave})`}
			onChange={changeHandler}
			name="NIE"
			value={values.NIE}
		/>
		</div>


		<div class='grid-column-left'>
		{touched.dateOfBirth && errors.dateOfBirth ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.dateOfBirth}</p>}
			<Spacer5 />
			<LocalizationProvider dateAdapter={AdapterDayjs}>
	{
		<DatePicker
				value={values.dateOfBirth}	
				format="DD/MM/YYYY"
				name="dateOfBirth"
			onChange={(date) => {
				try {
					//This first line is just done to ensure we throw an error if the date is invalid. date.format never throws an error and just return 'invalid date'
					if (date && date.isValid()) {
						const isoDateString = date.toISOString();
						//We don't want to actually store the date as an isoDateString because it stores timezone info, which can actually screw with the value of the date, making the DoB invalid
						const event = { target: { name: 'dateOfBirth', value: date } };
						console.log('date', isoDateString);
						changeHandler(event);
					} else {
						// Handle invalid date or null value
						const event = { target: { name: 'dateOfBirth', value: null } };
						changeHandler(event);
					}
					console.log('date errors', errors.dateOfBirth);
					console.log('touched date', touched.dateOfBirth);
				} catch {
					console.log('catch');
					console.log('date errors', errors.dateOfBirth);
					console.log('touched date', touched.dateOfBirth);
				}
			}}

				sx = {{
					'& .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root': {
						maxHeight: '50px',
						width: '100%',
						border: touched.dateOfBirth && errors.dateOfBirth ? '2px solid red' : '2px solid gray !important',
						fontSize: '1.1rem',
					},


					'& .css-1bn53lx': {
						maxHeight: '50px',
						maxWidth: '95%',
						border: touched.dateOfBirth && errors.dateOfBirth ? '2px solid red' : '2px solid gray',
						fontSize: '1.1rem',
						marginLeft: '16px',
					},



					'& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
						border: 'none',
					},

					'& .css-igs3ac': {
						border: 'none',
					}

					
				}}

				slotProps={{ 
					textField: { 
						placeholder: lang.dateOfBirth,
						onBlur: handleBlur
					} 
				}}
			/>
}
			</LocalizationProvider>
		</div>



		<div class='grid-column-left one-o-two'>
		{touched.countryOfBirth && errors.countryOfBirth ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.countryOfBirth}</p>}
		<Spacer5 />
		<Select
			onBlur={() => handleBlur({target: {name: 'countryOfBirth'}})}
			options={countries_list}
			value={values.countryOfBirth}
			onChange={selectedOption => {
				let event = {target: {name: 'countryOfBirth', value: selectedOption}}
				changeHandler(event);
			}}
// 			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder={lang.countryOfBirth}
			styles={touched.countryOfBirth && errors.countryOfBirth ? colorStylesError : colorStyles}
		>
		</Select>
		</div>

		
		<div class='grid-column-left'>
		{touched.placeOfBirth && errors.placeOfBirth ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.placeOfBirth}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.placeOfBirth && errors.placeOfBirth ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.placeOfBirth}
			onChange={changeHandler}
			name="placeOfBirth"
			value={values.placeOfBirth}
		/>
		</div>


		<div class='grid-column-left one-o-two'>
		{touched.countriesOfCitizenship && errors.countriesOfCitizenship ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.countriesOfCitizenship}</p>}
		<Spacer5 />
		<div className='center-flex'>
		<Select
			onBlur={() => handleBlur({target: {name: 'countriesOfCitizenship'}})}
			options={countries_list}
			value={values.countriesOfCitizenship}
			onChange={selectedOption => {
				let event = {target: {name: 'countriesOfCitizenship', value: selectedOption}}
				changeHandler(event)
			}}
			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder={lang.countriesOfCitizenship}
			isMulti={true}
			styles={touched.countriesOfCitizenship && errors.countriesOfCitizenship ? colorStylesError : colorStyles}
		>
		</Select>
		</div>
		</div>


		<div class='grid-column-left one-o-two'>
		{touched.gender && errors.gender ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.gender}</p>}
		<Spacer5 />
		<div className='center-flex'>
		<Select
			onBlur={() => handleBlur({target: {name: 'gender'}})}
			options={lang.legalGenderOptions}
			onChange={selectedOption => {
				let event = {target: {name: 'gender', value: selectedOption}}
				console.log(values)
				changeHandler(event)
			}}
			value={values.gender}
			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder={lang.gender}
			styles={touched.gender && errors.gender ? colorStylesError : colorStyles}

		>
		</Select>
		</div>
		</div>

		<div class='grid-column-left one-o-two'>
		{touched.civilStatus && errors.civilStatus ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.civilStatus}</p>}
		<Spacer5 />
		<div className='center-flex'>
		<Select
			menuPortalTarget={document.body}
			onBlur={() => handleBlur({target: {name: 'civilStatus'}})}
			options={civilStatusOptions}
			value={values.civilStatus}
			onChange={selectedOption => {
				let event = {target: {name: 'civilStatus', value: selectedOption}}
				changeHandler(event)
			}}
			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder="Civil Status..."
			styles={touched.civilStatus && errors.civilStatus ? colorStylesError : colorStyles}

		>
		</Select>
		</div>
		</div>


		<div class='grid-column-left'>
		{touched.fathersFullName && errors.fathersFullName ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.fathersFullName}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.fathersFullName && errors.fathersFullName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.fathersFullName}
			onChange={changeHandler}
			name="fathersFullName"
			value={values.fathersFullName}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.mothersFullName && errors.mothersFullName ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.mothersFullName}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.mothersFullName && errors.mothersFullName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.mothersFullName}
			onChange={changeHandler}
			name="mothersFullName"
			value={values.mothersFullName}
		/>
		</div>



		<Spacer />
	</form>
	);
}


export function EmployerFirm() {
	const {globalForm, setGlobalForm} = useContext(FormContext);

	const basicSchema = yup.object().shape({
		companyRepName: yup.string().required(),
		companyRepIDType: yup.object().required(),
		companyRepID: yup.string().required(),
		companyRepTitle: yup.string().required(),
	});

	let initialValues;

	if (globalForm.employerInfo) {
		initialValues = globalForm.employerInfo
	}
	else {
		initialValues = {
			companyRepName: '',
			companyRepIDType: '',
			companyRepID: '',
			companyRepTitle: '',
		}
	}

	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		if (event.target.type === 'checkbox') {
			const {name, checked} = event.target;
			setGlobalForm( prevGlobalForm => ({
				...prevGlobalForm,
				employerInfo: {
					...prevGlobalForm.employerInfo,
					[name]: checked,
				}
			}) );
			return;
		}
		const {name, value} = event.target;
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			employerInfo: {
				...prevGlobalForm.employerInfo,
				[name]: value,
			}
		}) )
		handleChange(event);
	}

	async function checkForm(formData) {
		try {
			await basicSchema.validate(formData, { abortEarly: false });
			return true; // All fields are valid
		} catch (err) {
			console.log(err.errors); // Contains all validation errors
			return false; // At least one field is invalid
		}
	}

	return (

	<form className='basic-form animated-div'>
		<div class='grid-column-left'>
		{touched.employerName && errors.employerName ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'>{lang.companyName}</p>}
		<Spacer5 />
		<input 
			className={`form-text-item ${touched.employerName && errors.employerName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.companyName}
			onChange={changeHandler}
			name="employerName"
			value={values.employerName}
		/>
		</div>


		<div class='grid-column-left'>
		{touched.employerID && errors.employerID ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'>{lang.companyNIF}</p>}
		<Spacer5 />
		<input 
			className={`form-text-item ${touched.employerID && errors.employerID ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.companyNIF}
			onChange={changeHandler}
			name="employerID"
			value={values.employerID}
		/>
		</div>


		<div class='grid-column-left'>
		{touched.employerEmail && errors.employerEmail ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.companyEmail}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.employerEmail && errors.employerEmail ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.companyEmail}
			onChange={changeHandler}
			name="employerEmail"
			value={values.employerEmail}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.employerPhone && errors.employerPhone ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.companyPhone}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.employerPhone && errors.employerPhone ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.companyPhone}
			onChange={changeHandler}
			name="employerPhone"
			value={values.employerPhone}
		/>
		</div>
		<div class='grid-column-left'>
		{touched.companyRepName && errors.companyRepName ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'>{lang.companyRepName}</p>}
		<Spacer5 />
		<input 
			className={`form-text-item ${touched.companyRepName && errors.companyRepName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.companyRepName}
			onChange={changeHandler}
			name="companyRepName"
			value={values.companyRepName}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.companyRepTitle && errors.companyRepTitle ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.companyRepTitle}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.companyRepTitle && errors.companyRepTitle ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.companyRepTitle}`}
			onChange={changeHandler}
			name="companyRepTitle"
			value={values.companyRepTitle}
		/>
		</div>



		<div class='grid-column-left one-o-two'>
		{touched.companyRepIDType && errors.companyRepIDType ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.companyRepIDType}</p>}
		<Spacer5 />
		<Select
			onBlur={() => handleBlur({target: {name: 'companyRepIDType'}})}
			options={lang.companyRepIDTypeOptions}
			value={values.companyRepIDType}
			onChange={selectedOption => {
				let event = {target: {name: 'companyRepIDType', value: selectedOption}}
				changeHandler(event);
			}}
// 			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder={lang.companyRepIDType}
			styles={touched.companyRepIDType && errors.companyRepIDType ? colorStylesError : colorStyles}
		>
		</Select>
		</div>


		<div class='grid-column-left'>
		{touched.companyRepID && errors.companyRepID ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'>{lang.companyRepID}</p>}
		<Spacer5 />
		<input 
			className={`form-text-item ${touched.companyRepID && errors.companyRepID ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.companyRepID}
			onChange={changeHandler}
			name="companyRepID"
			value={values.companyRepID}
		/>
		</div>


		<Spacer />
	</form>
	);
}

export function EmployerPerson() {
	const {globalForm, setGlobalForm} = useContext(FormContext);
	const phoneRegExp = /^(\+34\s?)?[6789]\d{2}[\s-]?\d{2}[\s-]?\d{2}[\s-]?\d{2}$/

	const basicSchema = yup.object().shape({
		employerName: yup.string().required(),
		employerIDType: yup.object().required(),
		employerID: yup.string().required(),
		employerEmail: yup.string().required(),
		employerPhone: yup.string().required(),
		activity: yup.object().required(),
		ocupation: yup.object().required(),
		cnoSPE2011: yup.object().required(),
		repName: yup.string().required(),
		repIDType: yup.string().required(),
		repID: yup.string().required(),
		repTitle: yup.string().required(),
	});

	let initialValues;

	if (globalForm.employerInfo) {
		initialValues = globalForm.employerInfo
	}
	else {
		initialValues = {
			employerName: '',
			employerIDType: '',
			employerID: '',
			employerEmail: '',
			employerPhone: '',
			activity: '',
			ocupation: '',
			cnoSPE2011: '',
			repName: '',
			repIDType: '',
			repID: '',
			repTitle: '',
		}
	}

	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});


	function changeHandler(event) {
		if (event.target.type === 'checkbox') {
			const {name, checked} = event.target;
			setGlobalForm( prevGlobalForm => ({
				...prevGlobalForm,
				employerInfo: {
					...prevGlobalForm.employerInfo,
					[name]: checked,
				}
			}) );
			return;
		}
		const {name, value} = event.target;
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			employerInfo: {
				...prevGlobalForm.employerInfo,
				[name]: value,
			}
		}) )
		handleChange(event);
	}

	async function checkForm(formData) {
		try {
			await basicSchema.validate(formData, { abortEarly: false });
			return true; // All fields are valid
		} catch (err) {
			console.log(err.errors); // Contains all validation errors
			return false; // At least one field is invalid
		}
	}

	return (
	<form className='basic-form animated-div'>
		<div class='grid-column-left'>
		{touched.employerName && errors.employerName ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'>{lang.employerName}</p>}
		<Spacer5 />
		<input 
			className={`form-text-item ${touched.employerName && errors.employerName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.employerName}
			onChange={changeHandler}
			name="employerName"
			value={values.employerName}
		/>
		</div>

		<div></div>

		<div class='grid-column-left one-o-two'>
		{touched.employerIDType && errors.employerIDType ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.employerIDType}</p>}
		<Spacer5 />
		<Select
			onBlur={() => handleBlur({target: {name: 'employerIDType'}})}
			options={lang.employerIDTypeOptions}
			value={values.employerIDType}
			onChange={selectedOption => {
				let event = {target: {name: 'employerIDType', value: selectedOption}}
				changeHandler(event);
			}}
// 			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder={lang.employerIDType}
			styles={touched.employerIDType && errors.employerIDType ? colorStylesError : colorStyles}
		>
		</Select>
		</div>

		<div class='grid-column-left'>
		{touched.employerID && errors.employerID ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'>{lang.employerID}</p>}
		<Spacer5 />
		<input 
			className={`form-text-item ${touched.employerID && errors.employerID ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.employerID}
			onChange={changeHandler}
			name="employerID"
			value={values.employerID}
		/>
		</div>


		<div class='grid-column-left'>
		{touched.employerEmail && errors.employerEmail ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.employerEmail}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.employerEmail && errors.employerEmail ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.employerEmail}`}
			onChange={changeHandler}
			name="employerEmail"
			value={values.employerEmail}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.employerPhone && errors.employerPhone ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.employerPhone}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.employerPhone && errors.employerPhone ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.employerPhone}`}
			onChange={changeHandler}
			name="employerPhone"
			value={values.employerPhone}
		/>
		</div>
	</form>
	);
}

export function School() {
	const {globalForm, setGlobalForm} = useContext(FormContext);

	const phoneRegExp = /^(\+34\s?)?[67]\d{2}[\s-]?\d{2}[\s-]?\d{2}[\s-]?\d{2}$/

	const basicSchema = yup.object().shape({
		courseType: yup.object().required(),
		schoolName: yup.string().required(),
		schoolNIF: yup.string().required(),
		courseName: yup.string().required(),
		courseCode: yup.string().required(),
		courseDuration: yup.number().required(),
		courseStartDate: yup.date().required(),
		courseEndDate: yup.date().required(),
		schoolPhone: yup.string().matches(phoneRegExp, 'Phone number not valid').required(),
		schoolEmail: yup.string().email().required(),
		classMode: yup.object().required(),
	});

	let initialValues;

	if (globalForm.schoolInfo) {
		initialValues = globalForm.schoolInfo
		initialValues.courseStartDate = dayjs(initialValues.courseStarteDate);
		initialValues.courseEndDate = dayjs(initialValues.courseEndDate);
		console.log("Initial values", initialValues);
	}
	else {
		initialValues = {
			courseType: '',
			schoolName: '',
			schoolNIF: '',
			courseName: '',
			courseCode: '',
			courseDuration: '',
			courseStartDate: dayjs(''),
			courseEndDate: dayjs(''),
			schoolPhone: '',
			schoolEmail: '',
			classMode: '',
		}

		console.log("Initial values empty", initialValues);
	}

	const {values, handleBlur, handleChange, touched, setFieldTouched , errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});

// 	console.log('BasicForm values', values);
// 	console.log('BasicForm globalForm', globalForm);

	function changeHandler(event) {
		if (event.target.type === 'checkbox') {
			const {name, checked} = event.target;
			setGlobalForm( prevGlobalForm => ({
				...prevGlobalForm,
				schoolInfo: {
					...prevGlobalForm.schoolInfo,
					[name]: checked,
				}
			}) );
		console.log('globalForm checkbox update', globalForm);
			return;
		}
		const {name, value} = event.target;
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			schoolInfo: {
				...prevGlobalForm.schoolInfo,
				[name]: value,
			}
		}) )
		handleChange(event);
	}

	async function checkForm(formData) {
		try {
			await basicSchema.validate(formData, { abortEarly: false });
			return true; // All fields are valid
		} catch (err) {
			console.log(err.errors); // Contains all validation errors
			return false; // At least one field is invalid
		}
	}

	return (
	<form className='basic-form animated-div'>
		<div class='grid-column-left'>
		{touched.schoolName && errors.schoolName ?
		<p className='alert required-text' for='firstname'>{lang.required}</p> : <p className='required-text p'>{lang.schoolName}</p>}
		<Spacer5 />
		<input 
			className={`form-text-item ${touched.schoolName && errors.schoolName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.schoolName}
			onChange={changeHandler}
			name="schoolName"
			value={values.schoolName}
		/>

		</div>

		<div class='grid-column-left'>
		{touched.schoolNIF && errors.schoolNIF ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.schoolNIF}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.schoolNIF && errors.schoolNIF ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.schoolNIF}`}
			onChange={changeHandler}
			name="schoolNIF"
			value={values.schoolNIF}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.schoolEmail && errors.schoolEmail ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.schoolEmail}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.schoolEmail && errors.schoolEmail ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.schoolEmail}`}
			onChange={changeHandler}
			name="schoolEmail"
			value={values.schoolEmail}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.schoolPhone && errors.schoolPhone ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.schoolPhone}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.schoolPhone && errors.schoolPhone ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.schoolPhone}`}
			onChange={changeHandler}
			name="schoolPhone"
			value={values.schoolPhone}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.courseName && errors.courseName ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.courseName}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.courseName && errors.courseName ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.courseName}`}
			onChange={changeHandler}
			name="courseName"
			value={values.courseName}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.courseCode && errors.courseCode ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.courseCode}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.courseCode && errors.courseCode ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.courseCode}`}
			onChange={changeHandler}
			name="courseCode"
			value={values.courseCode}
		/>
		</div>

		<div class='grid-column-left'>
		{touched.courseDuration && errors.courseDuration ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.courseDuration}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.courseDuration && errors.courseDuration ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.courseDuration}`}
			onChange={changeHandler}
			name="courseDuration"
			value={values.courseDuration}
		/>
		</div>

		<div class='grid-column-left one-o-two'>
		{touched.courseType && errors.courseType ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.courseType}</p>}
		<Spacer5 />
		<Select
			onBlur={() => handleBlur({target: {name: 'courseType'}})}
			options={lang.courseTypeOptions}
			value={values.courseType}
			onChange={selectedOption => {
				let event = {target: {name: 'courseType', value: selectedOption}}
				changeHandler(event);
			}}
// 			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder={lang.courseType}
			styles={touched.courseType && errors.courseType ? colorStylesError : colorStyles}
		>
		</Select>
		</div>

		<div class='grid-column-left'>
		{touched.courseStartDate && errors.courseStartDate ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.courseStartDate}</p>}
			<Spacer5 />
			<LocalizationProvider dateAdapter={AdapterDayjs}>
	{
		<DatePicker
				value={values.courseStartDate}	
				format="DD/MM/YYYY"
				name="courseStartDate"
			onChange={(date) => {
				try {
					//This first line is just done to ensure we throw an error if the date is invalid. date.format never throws an error and just return 'invalid date'
					if (date && date.isValid()) {
						const isoDateString = date.toISOString();
						//We don't want to actually store the date as an isoDateString because it stores timezone info, which can actually screw with the value of the date, making the DoB invalid
						const event = { target: { name: 'courseStartDate', value: date } };
						console.log('date', isoDateString);
						changeHandler(event);
					} else {
						// Handle invalid date or null value
						const event = { target: { name: 'courseStartDate', value: null } };
						changeHandler(event);
					}
					console.log('date errors', errors.courseStartDate);
					console.log('touched date', touched.courseStartDate);
				} catch {
					console.log('catch');
					console.log('date errors', errors.courseStartDate);
					console.log('touched date', touched.courseStartDate);
				}
			}}

				sx = {{
					'& .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root': {
						maxHeight: '50px',
						width: '100%',
						border: touched.courseStartDate && errors.courseStartDate ? '2px solid red' : '2px solid gray !important',
						fontSize: '1.1rem',
					},


					'& .css-1bn53lx': {
						maxHeight: '50px',
						maxWidth: '95%',
						border: touched.courseStartDate && errors.courseStartDate ? '2px solid red' : '2px solid gray',
						fontSize: '1.1rem',
						marginLeft: '16px',
					},



					'& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
						border: 'none',
					},

					'& .css-igs3ac': {
						border: 'none',
					}

					
				}}

				slotProps={{ 
					textField: { 
						placeholder: lang.courseStartDate,
						onBlur: handleBlur
					} 
				}}
			/>
}
			</LocalizationProvider>
		</div>

		<div class='grid-column-left'>
		{touched.courseEndDate && errors.courseEndDate ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.courseEndDate}</p>}
			<Spacer5 />
			<LocalizationProvider dateAdapter={AdapterDayjs}>
	{
		<DatePicker
				value={values.courseEndDate}	
				format="DD/MM/YYYY"
				name="courseEndDate"
			onChange={(date) => {
				try {
					//This first line is just done to ensure we throw an error if the date is invalid. date.format never throws an error and just return 'invalid date'
					if (date && date.isValid()) {
						const isoDateString = date.toISOString();
						//We don't want to actually store the date as an isoDateString because it stores timezone info, which can actually screw with the value of the date, making the DoB invalid
						const event = { target: { name: 'courseEndDate', value: date } };
						console.log('date', isoDateString);
						changeHandler(event);
					} else {
						// Handle invalid date or null value
						const event = { target: { name: 'courseEndDate', value: null } };
						changeHandler(event);
					}
					console.log('date errors', errors.courseEndDate);
					console.log('touched date', touched.courseEndDate);
				} catch {
					console.log('catch');
					console.log('date errors', errors.courseEndDate);
					console.log('touched date', touched.courseEndDate);
				}
			}}

				sx = {{
					'& .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root': {
						maxHeight: '50px',
						width: '100%',
						border: touched.courseEndDate && errors.courseEndDate ? '2px solid red' : '2px solid gray !important',
						fontSize: '1.1rem',
					},


					'& .css-1bn53lx': {
						maxHeight: '50px',
						maxWidth: '95%',
						border: touched.courseEndDate && errors.courseEndDate ? '2px solid red' : '2px solid gray',
						fontSize: '1.1rem',
						marginLeft: '16px',
					},



					'& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
						border: 'none',
					},

					'& .css-igs3ac': {
						border: 'none',
					}

					
				}}

				slotProps={{ 
					textField: { 
						placeholder: lang.courseEndDate,
						onBlur: handleBlur
					} 
				}}
			/>
		}
		</LocalizationProvider>
		</div>

		<div class='grid-column-left one-o-two'>
		{touched.classMode && errors.classMode ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.classMode}</p>}
		<Spacer5 />
		<Select
			onBlur={() => handleBlur({target: {name: 'classMode'}})}
			options={lang.classModeOptions}
			value={values.classMode}
			onChange={selectedOption => {
				let event = {target: {name: 'classMode', value: selectedOption}}
				changeHandler(event);
			}}
// 			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder={lang.classMode}
			styles={touched.classMode && errors.classMode ? colorStylesError : colorStyles}
		>
		</Select>
		</div>



		<Spacer />
	</form>
	);


}

export function AddressForm({employer = false, school = false } = {}) {
	const {globalForm, setGlobalForm} = useContext(FormContext);
	const addrKey = employer === true ? 'employerAddress' : school === true ? 'schoolAddress' : 'address';

	const basicSchema = yup.object().shape({
		typeOfStreet: yup.object().required(),
		street: yup.string().required(),
		streetNumber: yup.number().required(),
		countryOfResidence: yup.object().required(),
		postalCode: yup.number().required(),
		province: yup.string().required(),
		city: yup.string().required(),
	})

	let initialValues;
	if (globalForm[addrKey]) {
		initialValues = globalForm[addrKey]
	}
	else {
		initialValues = {
			typeOfStreet: '',
			street: '',
			streetNumber: '',
			apt: '',
			countryofResidence: '',
			postalCode: '',
			province: '',
			city: '',
		}
	}


	const {values, handleBlur, handleChange, touched, handleSubmit, errors} = useFormik({
		initialValues: initialValues,
		validationSchema: basicSchema,
	});

	function changeHandler(event) {
		const {name, value} = event.target;
		setGlobalForm( prevGlobalForm => ({
			...prevGlobalForm,
			[addrKey]: {
				...prevGlobalForm[addrKey],
				[name]: value,
			}
		}) )
		handleChange(event);
		console.log('globalForm', globalForm);
	}


	return(
	<form className='basic-form animated-div'>
		
		<div class='grid-column-left one-o-two'>
		{touched.typeOfStreet && errors.typeOfStreet ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.typeOfStreet}</p>}
		<Spacer5 />
		<div className='center-flex'>
		<Select
			menuPortalTarget={document.body}
			onBlur={() => handleBlur({target: {name: 'typeOfStreet'}})}
			options={typeOfStreetOptions}
			value={values.typeOfStreet}
			onChange={selectedOption => {
				let event = {target: {name: 'typeOfStreet', value: selectedOption}}
				changeHandler(event)
			}}
			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder="Type of street..."
			styles={
				touched.typeOfStreet && errors.typeOfStreet ? colorStylesError : colorStyles
			}
		>
		</Select>
		</div>
		</div>


		<div class='grid-column-left'>
		{touched.street && errors.street ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.street}</p>}
		<Spacer5 />
		<input className={`form-text-item ${touched.street && errors.street ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.street}
			onChange={changeHandler}
			name="street"
			value={values.street}
		/>
		</div>


		<div class='grid-column-left'>
		{touched.streetNumber && errors.streetNumber ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.streetNumber}</p>}
		<Spacer5 />
		<input className={`form-text-item address-text-input ${touched.streetNumber && errors.streetNumber ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.streetNumber}
			onChange={changeHandler}
			name="streetNumber"
			value={values.streetNumber}
		/>
		</div>


		<div class='grid-column-left'>
		<p className='required-text p'>{lang.apt}</p>
		<input className='form-text-item address-text-input form-element'
			onBlur={handleBlur}
			type="text"
			placeholder={`${lang.apt}  (${lang.requiredIfYouLive})`}
			onChange={changeHandler}
			name="apt"
			value={values.apt}
		/>
		</div>

		<div class='grid-column-left one-o-two'>
		{touched.countryOfResidence && errors.countryOfResidence ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.country}</p>}
		<Spacer5 />
		<div className='center-flex'>
	{
		<Select
			isDisabled={true}
			defaultValue={{ value: "ES", label: "Spain" }}
			onBlur={() => handleBlur({target: {name: 'countryOfResidence'}})}
			options={countries_list}
			value={values.countryOfResidence}
			onChange={selectedOption => {
				let event = {target: {name: 'countryOfResidence', value: selectedOption}}
				changeHandler(event)
			}}
			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder="Select country..."
			styles={touched.countryOfResidence && errors.countryOfResidence ? colorStylesError : colorStyles}
		>
		</Select>
	}
		</div>
		</div>

		<div class='grid-column-left'>
		{touched.postalCode && errors.postalCode ?
		<p className='alert required-text'>{lang.invalid}</p> : <p className='required-text p'>{lang.postalCode}</p>}
		<Spacer5 />
		<input className={`form-text-item address-text-input ${touched.postalCode && errors.postalCode ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.postalCode}
			onChange={changeHandler}
			name="postalCode"
			value={values.postalCode}
		/>
		</div>

{
// 		<div class='grid-column-left'>
// 		{touched.province && errors.province ?
// 		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.province}</p>}
// 		<Spacer5 />
// 		<input className={`form-text-item address-text-input ${touched.province && errors.province ? 'input-error' : ''} form-element`} 
// 			onBlur={handleBlur}
// 			type="text"
// 			placeholder={lang.province}
// 			onChange={changeHandler}
// 			name="province"
// 			value={values.province}
// 		/>
// 		</div>
}

		<div class='grid-column-left one-o-two'>
		{touched.province && errors.province ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.province}</p>}
		<Spacer5 />
		<div className='center-flex'>
		<Select
			onBlur={() => handleBlur({target: {name: 'province'}})}
			options={spanish_provinces}
			value={values.province}
			onChange={selectedOption => {
				let event = {target: {name: 'province', value: selectedOption}}
				changeHandler(event)
			}}
			classNamePrefix='form-text-item'
			className='form-select-dropdown'
			placeholder="Select province..."
			styles={touched.province && errors.province ? colorStylesError : colorStyles}
		>
		</Select>
		</div>
		</div>


		<div class='grid-column-left'>
		{touched.city && errors.city ?
		<p className='alert required-text'>{lang.required}</p> : <p className='required-text p'>{lang.city}</p>}
		<Spacer5 />
		<input className={`form-text-item address-text-input ${touched.city && errors.city ? 'input-error' : ''} form-element`} 
			onBlur={handleBlur}
			type="text"
			placeholder={lang.city}
			onChange={changeHandler}
			name="city"
			value={values.city}
		/>
		</div>




	</form>

	);


}


export function SubmissionArea({saveFunc, signatureImg}) {
	const [submitPopup, setSubmitPopup] = useState('hidden');
	const [isVisible, setIsVisible] = useState('hidden');
	const [littlePopupText, setLittlePopupText] = useState(lang.draftSaved);
	const [isAlert, setIsAlert] = useState(false);
	const {globalForm, setGlobalForm} = useContext(FormContext);

	function handleSubmit() {
		console.log('handle submit')
		saveFunc(globalForm);
		setSubmitPopup('animated-div');
		const pdfBlob = MyPDFDownloadLink(globalForm, DecRespAutorizaciones, signatureImg);
// 		document.getElementById('grad-focus').focus()
	}

	async function validateSubmit() {
		const isFormValid = await validateNewCaseForm(globalForm);
		console.log('isFormValid', isFormValid);
		if (!isFormValid) {
			invalidForm();
			return;
		}
		handleSubmit();
	}
	
	function saveDraft() {
		setIsAlert(false);
		setLittlePopupText(lang.draftSaved)
		setIsVisible('fade-in');
		saveFunc();
		setTimeout( () => {
			setIsVisible('');
			setTimeout( () => {
				setIsVisible('fade-out');
			}, 1500);
			
		}, 500);

	}

	function invalidForm() {
		setIsAlert(true);
		setLittlePopupText(lang.invalidForm)
		setIsVisible('fade-in');
		saveFunc();
		setTimeout( () => {
			setIsVisible('');
			setTimeout( () => {
				setIsVisible('fade-out');
			}, 3000);
			
		}, 500);

	}


	return(
	<div>
	<div className='submission-area'>
		<button className='form-action-btn' onClick={saveDraft}>{lang.saveDraft}</button>
		<button className='form-action-btn' onClick={validateSubmit}>{lang.submit}</button>
		<p className={`${isVisible} centered-text little-popup ${isAlert ? 'alert' : ''}`}>{littlePopupText}</p>
	</div>
		<SubmitApplicationPopup trigger={submitPopup} submitPopup={submitPopup} closeFunc={setSubmitPopup} />

	</div>
	);
}


export function ConfirmNewCase({setConfirmNewCase}) {
	const navigate = useNavigate();	
	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 1000px)');	
	let isShortScreen = !useMediaQuery('screen and (min-height: 825px)');
	const [smallScreenClass, setIsSmallScreenClass] = useState(isMobilePortraitScreen ? 'max-width-80' : '');
	const [shortScreenClass, setShortScreenClass] = useState(isShortScreen ? {} : {marginTop: '-50px'}); 

	function handleYes() {
		setConfirmNewCase(false);
	}

	useEffect(() => {
			setIsSmallScreenClass(isMobilePortraitScreen ? 'max-width-80' : '');
	}, [isMobilePortraitScreen]);


	useEffect(() => {
			setShortScreenClass( isShortScreen ? {} : {marginTop: '-50px'});
	}, [isShortScreen]);

	return (
	<div className='fade-in'>

	<div className='popup' style={shortScreenClass}>
		<div className='inner-popup'>
		<div className=''>
			<div className='right-flex'>
				<button className='close-button' onClick={() => navigate('/')}></button>
			</div>
			<div className='center-flex'>
				<img src={newCaseImg} alt='new case image' width='300' />
			</div>
			<Spacer10 />
			<div className='grid-column'>
			<h1 className={`primary-title ${smallScreenClass}`}>{lang.confirmNewCase}</h1>
			<Spacer25 />
			<Spacer25 />
			<p className={`p ${smallScreenClass}`}>{lang.existingCaseType}</p>
			<Spacer />
			<p className={`p ${smallScreenClass}`}>{lang.caseLimit}</p>
			<Spacer />
			<div className='center-flex popup-btn-grid'>
				<button className='popup-andrey-button-2 small-margin' onClick={() => navigate('/')}>{lang.poshNo}</button>
				<button className='popup-andrey-button small-margin' onClick={() => handleYes()}>{lang.poshYes}</button>
			</div>
			</div>	
		</div>
		</div>
		
	</div>
	</div>
	)
}

export function NoCasesAvailable() {
	const navigate = useNavigate();	
	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 1000px)');	
	let isShortScreen = !useMediaQuery('screen and (min-height: 825px)');
	const [smallScreenClass, setIsSmallScreenClass] = useState(isMobilePortraitScreen ? 'max-width-80' : '');
	const [shortScreenClass, setShortScreenClass] = useState(isShortScreen ? {} : {marginTop: '-50px'}); 

	function handleYes() {
// 		setConfirmNewCase(false);
	}

	useEffect(() => {
			setIsSmallScreenClass(isMobilePortraitScreen ? 'max-width-80' : '');
	}, [isMobilePortraitScreen]);


	useEffect(() => {
			setShortScreenClass( isShortScreen ? {} : {marginTop: '-50px'});
	}, [isShortScreen]);

	return (
	<div className='fade-in'>

	<div className='popup' style={shortScreenClass}>
		<div className=''>
			<div className='right-flex'>
				<button className='close-button' onClick={() => navigate('/')}></button>
			</div>
			<div className='center-flex'>
				<img src={newCaseImg} alt='new case image' width='300' />
			</div>
			<Spacer10 />
			<div className='grid-column'>
			<h1 className={`primary-title ${smallScreenClass}`}>{lang.noCasesAvailable}</h1>
			<Spacer25 />
			<Spacer25 />
			<p className={`p ${smallScreenClass}`}>{lang.buyMoreCases}<Link to='https://continentalis.eu/shop'>{lang.here}</Link></p>
			<Spacer />
			<p className={`p ${smallScreenClass}`}>{lang.caseLimit}</p>
			<Spacer />
			<div className='center-flex'>
				<button className='popup-andrey-button-2 small-margin' onClick={() => navigate('/')}>{lang.backToHome}</button>
			</div>
			</div>	
		</div>
		
	</div>
	</div>
	)
}


export function PageNotFound() {
	return(
	<div>
		<BackButton />
		<Spacer100 />
		<h1 className='primary-title-center'>404 Page Not Found</h1>
	</div>
	);
}

export function ResponsibleDeclarations() {
	const {globalForm, setGlobalForm, resolverRef} = useContext(FormContext);
	const rd = lang.responsibleDeclarations;
	const caseType = globalForm.caseType;

	function changeHandler(event) {
		let {name, checked, value} = event.target;
		console.log('Name', name, 'Checked', checked, 'Value', value)
		//IMPORTANT!! This function will be called automatically "onChange" and we don't want that. Do not remove the following line.
		if (name === undefined) return;
		if (name === 'previousDeniedForPublicSafety') {
			setGlobalForm( prevGlobalForm => ({
				...prevGlobalForm,
				responsibleDecs: {
					...prevGlobalForm.responsibleDecs,
					[name]: value,
				}
			}) );
		}
		else {
			setGlobalForm( prevGlobalForm => ({
				...prevGlobalForm,
				responsibleDecs: {
					...prevGlobalForm.responsibleDecs,
					[name]: checked,
				}
			}) );
		}
		return;
	}

	
	return(
		<>
		<h3 className='tertiary-title'>{lang.responsibleDeclarationsStr}</h3>
		<Spacer25 />
		<FormGroup className='responsible-decs'>
			<FormControlLabel control={<Checkbox defaultChecked={!!globalForm.responsibleDecs.noInternationalProtection}/>} label={<Typography sx={{fontSize: '1.1rem'}}>{rd.noInternationalProtection} <span style={{color: 'red'}}>*</span></Typography>} onChange={changeHandler} name='noInternationalProtection' />
			<Spacer10 />
			{ caseType !== 'arraigoFamiliar' && <FormControlLabel control={<Checkbox defaultChecked={!!globalForm.responsibleDecs.arraigoTimeRequirement}/>} label={<Typography sx={{fontSize: '1.1rem'}}>{rd.arraigoTimeRequirement} <span style={{color: 'red'}}>*</span></Typography>} onChange={changeHandler} name='arraigoTimeRequirement'/>}
			{ caseType !== 'arraigoFamiliar' && <Spacer10 /> }
			<FormControlLabel control={<Checkbox defaultChecked={!!globalForm.responsibleDecs.noThreat} />} label={<Typography sx={{fontSize: '1.1rem'}}>{rd.noThreat} <span style={{color: 'red'}}>*</span></Typography>} onChange={changeHandler} name={'noThreat'}/>
			<Spacer10 />
			<FormControlLabel control={<Checkbox defaultChecked={!!globalForm.responsibleDecs.noCriminalRecord} />} label={<Typography sx={{fontSize: '1.1rem'}}>{rd.noCriminalRecord} <span style={{color: 'red'}}>*</span></Typography>} onChange={changeHandler} name='noCriminalRecord'/>
		</FormGroup>
		{
			caseType === 'arraigoSegundaOportunidad' &&
			<>
			<Spacer />
			<h3 className='tertiary-title'>{lang.publicSafety} <span style={{color: 'red'}}>*</span></h3>
			<Spacer25 />
			<RadioGroup 
				className='responsible-decs'
				name='segundaOportunidad'
				defaultValue={globalForm.responsibleDecs.previousDeniedForPublicSafety}
			>
				<FormControlLabel control={<Radio />} label={<Typography sx={{fontSize: '1.1rem'}}>{rd.previousNotDeniedForPubSafety}</Typography>} onChange={changeHandler} name='previousDeniedForPublicSafety' value={false} />
				<Spacer10 />
				<FormControlLabel control={<Radio />} label={<Typography sx={{fontSize: '1.1rem'}}>{rd.prevousDeniedForPublicSafety}</Typography>} onChange={changeHandler} name='previousDeniedForPublicSafety' value={true} />
			</RadioGroup>
			</>
		}

		<Spacer />
		<h3 className='tertiary-title'>{lang.poa}</h3>
		<Spacer25 />
		<FormGroup className='responsible-decs'>
			<FormControlLabel control={<Checkbox value={!!globalForm.responsibleDecs.poaLater} />} label={<Typography sx={{fontSize: '1.1rem'}}>{rd.poaLater} <span style={{color: 'red'}}>*</span></Typography>} onChange={changeHandler} name='poaLater'/>
		</FormGroup>

		</>
	);
}

export function CriminalRecordsCheck({setBgchkVisible}){
	const {globalForm, setGlobalForm, resolverRef} = useContext(FormContext);
	const label = { slotProps: { input: { 'aria-label': 'Checkbox demo' } } };
	const rd = lang.responsibleDeclarations;
	const caseType = globalForm.caseType;
	const [bgchkExemption, setBgchkExemption] = useState(globalForm.responsibleDecs.bgchkExemption ?? null);
	const toolTips = strs.en.toolTips;
	const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
	const [anchorEl, setAnchorEl] = useState(null);
	const handleClick = (event) => setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);
	const [isVisible, setIsVisible] = useState(false)
	


	function changeHandler(event) {
		console.log('SETBGCHKVISIBLE', setBgchkVisible)
		let {name, checked, value} = event.target;
		console.log('Name', name, 'Checked', checked, 'Value', value)
		//IMPORTANT!! This function will be called automatically "onChange" and we don't want that. Do not remove the following line.
		setBgchkExemption(value);
		if (name === undefined) return;
			setGlobalForm( prevGlobalForm => ({
				...prevGlobalForm,
				responsibleDecs: {
					...prevGlobalForm.responsibleDecs,
					[name]: value,
				}
			}) );
		if (value === 'bgchk') {
			setBgchkVisible('large-margin animated-div');
		}
		else {
			setBgchkVisible('hidden');
		}

			return;
		}

	return(
	<>
			<h3 
				className='tertiary-title'>
				{lang.criminalRecordPresentationExemption}
				<span style={{color: 'red'}}>* </span>

			{
			<span>
			<span 	
				onClick={(e) => setAnchorEl(e.currentTarget)}
				style={{ cursor: 'help' }}>
				<HelpOutline 	onClick={(e) => setAnchorEl(e.currentTarget)} />
			</span>

			<Popover
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleClose}

				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				  slotProps={{
				paper: {
				  sx: {
					backgroundColor: 'rgba(97, 97, 97, 0.95)',
					color: 'white',
					p: 2,
					maxWidth: 400,
					borderRadius: 1,
					boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
				  },
				},
				backdrop: {
				  onClick: handleClose,
				  sx: { backgroundColor: 'transparent' },
				},
  }}
			>
				<Box p={2}>
						<div style={{fontSize: '1.1em'}}>
							<p>{toolTips.bgchksP1}</p>
							<br />
							<p>{toolTips.bgchksP2}</p>
							<br />
							<p><b><i>{toolTips.bgchksBold1}</i></b></p>
							<br />
							<p>{toolTips.bgchksEnd}</p>
						</div>

				</Box>
			</Popover>
			</span>

			}
			{
// 				<Tooltip 
// 					title={
// 						<div style={{fontSize: '1.5em'}}>
// 							<p>{toolTips.bgchksP1}</p>
// 							<br />
// 							<p>{toolTips.bgchksP2}</p>
// 							<br />
// 							<p><b><i>{toolTips.bgchksBold1}</i></b></p>
// 							<br />
// 							<p>{toolTips.bgchksEnd}</p>
// 						</div>
// 					} 
// 					placement='top' arrow
// 					slotProps={{ tooltip: { sx: { maxWidth: 800 } } }}
// 				>
// 					<HelpOutline />
// 				</Tooltip>
			}
			</h3>

			<Spacer25 />
			<Spacer25 />
		<RadioGroup className='responsible-decs' onChange={changeHandler} value={bgchkExemption}>
			<FormControlLabel 
				control={<Radio />} 
				label={<Typography sx={{fontSize: '1.1rem'}}>{rd.inSpain5Years}</Typography>} 	
				onClick={changeHandler} 
				name='bgchkExemption'
				value='inSpain5Years' 
			/>
			<FormControlLabel 
				control={<Radio />} 
				label={<Typography sx={{fontSize: '1.1rem'}}>{rd.notInSpain5Years}</Typography>} 
				onClick={changeHandler} 
				name='bgchkExemption' 
				value='notInSpain5Years' 
			/>
			<Spacer25 />
			<FormControlLabel 
				control={<Radio />} 
				label={<Typography sx={{fontSize: '1.1rem'}}>{rd.iNeedBgchk}</Typography>} 
				onClick={changeHandler} 
				name='bgchkExemption' 
				value='bgchk' 
			/>

			</RadioGroup>

	</>

	);

}

export function SignaturePad({ saveFunc, updateSignatureImg }) {
	const {globalForm, setGlobalForm, resolverRef} = useContext(FormContext);
	const [sigKey, setSigKey] = useState(0); // Key to force re-render
	const sigCanvas = useRef(null);

	const [submitPopup, setSubmitPopup] = useState('hidden');
	const [isVisible, setIsVisible] = useState('hidden');
	const [littlePopupText, setLittlePopupText] = useState(lang.draftSaved);
	const [isAlert, setIsAlert] = useState(false);

	function clear() {
// 		sigCanvas.current.clear();
		setSigKey((prevKey) => prevKey + 1); // Change key to trigger remount

	}

	function saveAlert() {
		setIsAlert(false);
		setLittlePopupText(lang.savedSignature)
		setIsVisible('fade-in');
		setTimeout( () => {
			setIsVisible('');
			setTimeout( () => {
				setIsVisible('fade-out');
			}, 1500);
			
		}, 500);

	}

	function invalidForm() {
		setIsAlert(true);
		setLittlePopupText(lang.saveErrorSignature)
		setIsVisible('fade-in');
		setTimeout( () => {
			setIsVisible('');
			setTimeout( () => {
				setIsVisible('fade-out');
			}, 3000);
			
		}, 500);

	}


	async function save() {
		let dataURL = null;
		try {
			dataURL = await sigCanvas.current.getTrimmedCanvas().toDataURL("image/png", "Anonymous");

		}
		catch (e) {
			console.error("Canvas is tained. Already saved", e);
			//We don't need to tell the client they already saved it. Just tell them you've saved it again.
			saveAlert();
			return
		}
		try {
// 			//Convert Base64 to a File object
			const file = dataURLtoFile(dataURL, "signature.png");
// 			//Upload using your existing function
// 			//the third parameter is `signature`
			const fileNanoId = await uploadFile(file, 'signature', true);
			const tmpForm = {
				...globalForm,
				signature: fileNanoId,
			};
			setGlobalForm(tmpForm);
	 		saveFunc(tmpForm);
			updateSignatureImg(dataURL);
			saveAlert();
		}
		catch (e) {
			console.error("Canvas is tainted", e);	
			invalidForm()
		}


	}

	useEffect(() => {
		const wrapperAsync = async () => {
			if (globalForm.signature) {

				const fileURL = await getFile(globalForm.signature, true, true)
				sigCanvas.current.fromDataURL(fileURL, "Anonymous");	
				updateSignatureImg(fileURL);
				}
			}
		wrapperAsync();
	}, []);

  return (
	<div>
		<SignatureCanvas 
	  		key={sigKey}
	  		ref={sigCanvas} 
	  		penColor="black" 
	  		canvasProps={{ className: "sigCanvas" }} 
	  	/>
		<Spacer25 />
		<div className='centered-text'>
			  <button className='del-button' onClick={clear}>Clear</button>
			  <button className='del-button' onClick={save}>Save</button>
		</div>
		<p className={`${isVisible} centered-text little-popup ${isAlert ? 'alert' : ''}`}>{littlePopupText}</p>
	  <Spacer />
	</div>
  );
}


